import React from 'react';
import { LuTriangleAlert, LuRotateCw } from 'react-icons/lu';

export function Skeleton({ lines = 3, height = 14 }) {
  return (
    <div className="pqd-skeleton" aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className="rt-skeleton" style={{ height, width: `${92 - ((i * 17) % 40)}%` }} />
      ))}
    </div>
  );
}

export function SectionError({ message, onRetry }) {
  return (
    <div className="pqd-state pqd-state--error" role="alert">
      <LuTriangleAlert size={18} aria-hidden="true" />
      <div>
        <strong>Couldn&apos;t load this section</strong>
        <p>{message}</p>
      </div>
      {onRetry && (
        <button type="button" className="rt-btn rt-btn--secondary rt-btn--sm" onClick={onRetry}>
          <LuRotateCw size={13} aria-hidden="true" /> Retry
        </button>
      )}
    </div>
  );
}

export function SectionEmpty({ title, children, action }) {
  return (
    <div className="pqd-state" role="status">
      <div>
        <strong>{title}</strong>
        {children && <p>{children}</p>}
      </div>
      {action}
    </div>
  );
}

/**
 * Card shell shared by every dashboard section: header, optional actions,
 * and loading / error states so each section renders independently.
 */
export default function SectionCard({
  id,
  title,
  subtitle,
  actions,
  loading,
  error,
  onRetry,
  refreshing,
  skeletonLines = 4,
  className = '',
  children,
}) {
  const headingId = id ? `${id}-title` : undefined;
  return (
    <section
      className={`pqd-card ${refreshing ? 'pqd-card--refreshing' : ''} ${className}`.trim()}
      aria-labelledby={headingId}
      aria-busy={loading || refreshing || undefined}
    >
      <header className="pqd-card__header">
        <div>
          <h2 className="pqd-card__title" id={headingId}>{title}</h2>
          {subtitle && <p className="pqd-card__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="pqd-card__actions">{actions}</div>}
      </header>
      <div className="pqd-card__body">
        {loading && <Skeleton lines={skeletonLines} />}
        {!loading && error && <SectionError message={error} onRetry={onRetry} />}
        {!loading && !error && children}
      </div>
    </section>
  );
}
